import { reactive } from 'vue';
import { useHeader } from './useHeader.js';

import * as api from '../../services/user';
import { isNuc } from '@/utils/env';

export function useHeaderPart(projectId) {
  const state = reactive({
    userInfo: {}
  });

  api.getUserInfo(projectId).then(res => {
    if (res.data.status === 'success' || res.data.success) {
      state.userInfo = {
        ...res.data.data,
        'user_real_name': res.data.data.userName,
      };
    } else {
      state.userInfo = {
        'user_real_name': '未登录',
      };
    }
  });
  const { logout } = useHeader();
  function userMenuClick(e) {
    if (e.key === '1') {
      logout();
    } else if (e.key === '2') {
      // 修改密码
      if (isNuc) {
        window.__openChangePwdDialog && window.__openChangePwdDialog();
      } else if (window._lkLoginJS) {
        window._lkLoginJS({
          type: 'change-pass',
          cb: function goToLoginPage() {
            window.location.replace('/login');
          }
        });
      } else {
        message.error('服务异常, 请稍后重试');
        throw new Error('私有化部署 login.js file is not find. please check your root/public directory whether it has login.js or not.');
      }
    }
  }
  return {
    state,
    userMenuClick
  };
}